module.exports = __webpack_public_path__ + "static/media/AgreeFisheries27.1e26c28a.jpg";